module.exports = __webpack_public_path__ + "img/security-on.4507075c.png";